import { GetTimeFromTimestamp, MaterialList, MultipleGabeImportJobs, UglImportTask } from '@dave/types';
import { LedgerImportStatusEnum } from './ledger-import.entity';
import { BackendDateTimestamp } from '../helper/backend-frontend-conversion.helper';



export class  UglImportTaskEntity {
    constructor(
        public Id: number = null,
        public PartnerId: number = null,
        public SupplierId: number = null,
        public Name: string = null,
        public FtpHost: string = null,
        public FtpPort: number = null,
        public FtpUser: string = null,
        public FtpPassword: string = null,
        public Path: string = null,
        public Interval: number = null,
        public Active: boolean = null,
        public UpdatedAt: Date = null,
        public CreatedAt: Date = null,
        public DeletedAt: Date = null,
    ) {}

    public static EntityName = 'UglImportTask';
    public Clone(override: Partial<UglImportTaskEntity> = {}): UglImportTaskEntity {
        const attr = { ...this, ...override };
        return Object.assign(new UglImportTaskEntity(), attr);
    }
}

export function UglImportTaskEntityFromBackend(res: UglImportTask): UglImportTaskEntity {

    return new UglImportTaskEntity(
        res.Id && +res.Id,
        res.PartnerId && +res.PartnerId,
        res.SupplierId && +res.SupplierId,
        res.Name,
        res.FtpHost,
        res.FtpPort && +res.FtpPort,
        res.FtpUser,
        res.FtpPassword,
        res.Path,
        res.Interval,
        res.Active,
        res.UpdatedAt && GetTimeFromTimestamp(+res.UpdatedAt),
        res.CreatedAt && GetTimeFromTimestamp(+res.CreatedAt),
        res.DeletedAt && GetTimeFromTimestamp(+res.DeletedAt),
    );
}
